<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-03-11 15:40:00
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-06-12 15:53:03
 * @FilePath: \xjlightingdp\src\views\LoginView.vue
 * @Description: 登录页面
-->
<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <div class="logo-icon">
          <!-- <i class="el-icon-bell"></i> -->
          <img src="../assets/logo.png" style="width: 65px;height: 65px;" alt="">
        </div>
        <h2 class="title">新疆阿克苏地区雷电监测预警平台</h2>
        <p class="subtitle">用户登录</p>
      </div>
      
      <el-form ref="loginForm" :model="loginForm" :rules="rules" class="login-form" @keyup.enter.native="handleLogin">
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            size="medium"
            autocomplete="off">
          </el-input>
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="medium"
            autocomplete="off">
          </el-input>
        </el-form-item>
        
        <el-form-item>
          <el-checkbox v-model="loginForm.remember">记住我</el-checkbox>
          <el-link type="primary" style="float: right">忘记密码？</el-link>
        </el-form-item>
        
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            class="login-btn"
            @click="handleLogin"
            :loading="loading">
            <i v-if="loading" class="el-icon-loading"></i>
            <span v-else>登 录</span>
          </el-button>
        </el-form-item>
      </el-form>
      
      <div class="login-footer">
        <p>© 2026 新疆阿克苏地区雷电监测预警平台 版权所有</p>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  data() {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        remember: false
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    const { token } = this.$route.query;
    if (token) {
      try {
        const decoded = atob(token);
        const [username, password] = decoded.split(':');
        if (username && password) {
          this.loginForm.username = username;
          this.loginForm.password = password;
          this.doLogin();
        }
      } catch (e) {
        console.error('Token解析失败:', e);
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.doLogin();
        } else {
          this.$message.error('请填写完整信息');
          return false;
        }
      });
    },
    doLogin() {
      this.loading = true;
      this.$axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        url: `${this.$url}/user/login?username=${this.loginForm.username}&password=${this.loginForm.password}`
      }).then((res) => {
        console.log(res);
        this.loading = false;
        if (res.data.code == '500') {
          this.$message({
            message: res.data.message,
            type: 'warning'
          });
        } else {
          this.$message({
            message: '登录成功',
            type: 'success'
          });

          Cookies.set('roundMap', JSON.stringify([[res.data.data.top, res.data.data.left], [res.data.data.bottom, res.data.data.right]]));
          Cookies.set('factoryid', res.data.data.factory);
          Cookies.set('areaCode', res.data.data.areaCode);
          Cookies.set('areaName', res.data.data.areaName);
          Cookies.set('regionpath', res.data.data.regionpath);
          Cookies.set('regionpath_out', res.data.data.regionpath_out);
          if (this.loginForm.remember) {
            localStorage.setItem('username', this.loginForm.username);
            localStorage.setItem('password', this.loginForm.password);
          } else {
            localStorage.removeItem('username');
            localStorage.removeItem('password');
          }
          this.$router.push('/home');
        }
      }).catch((error) => {
        this.loading = false;
        this.$message.error('登录失败：' + (error.message || '网络错误'));
      });
    }
  }
};
</script>

<style>
* {
  box-sizing: border-box;
}

.login-container {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #0e122d 0%, #1a1f3d 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.login-container::before {
  content: '';
  position: absolute;
  width: 150%;
  height: 150%;
  background: radial-gradient(circle, rgba(42, 142, 241, 0.1) 0%, transparent 60%);
  animation: rotate 60s linear infinite;
}

.login-container::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: 
    linear-gradient(rgba(42, 142, 241, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(42, 142, 241, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  opacity: 0.3;
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.login-box {
  width: 420px;
  padding: 40px;
  background: rgba(14, 18, 45, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  border: 1px solid rgba(42, 142, 241, 0.3);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5), 0 0 40px rgba(42, 142, 241, 0.2);
  position: relative;
  z-index: 10;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #2a8ef1 0%, #0066cc 100%);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 30px rgba(42, 142, 241, 0.5);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { box-shadow: 0 0 30px rgba(42, 142, 241, 0.5); }
  50% { box-shadow: 0 0 50px rgba(42, 142, 241, 0.8); }
}

.logo-icon i {
  color: #ffffff;
  font-size: 28px;
}

.title {
  color: #ffffff;
  font-size: 22px;
  font-weight: bold;
  margin: 0 0 10px;
  text-shadow: 0 0 20px rgba(42, 142, 241, 0.3);
}

.subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin: 0;
}

.login-form {
  margin-top: 20px;
}

.login-form .el-form-item {
  margin-bottom: 25px;
}

.login-form .el-input__inner {
  background: rgba(14, 18, 45, 0.6);
  border: 1px solid rgba(42, 142, 241, 0.3);
  border-radius: 10px;
  color: #ffffff;
  padding-left: 40px;
  height: 45px;
  transition: all 0.3s ease;
}

.login-form .el-input__inner:hover {
  border-color: #2a8ef1;
  box-shadow: 0 0 15px rgba(42, 142, 241, 0.2);
}

.login-form .el-input__inner:focus {
  border-color: #2a8ef1;
  box-shadow: 0 0 20px rgba(42, 142, 241, 0.4);
}

.login-form .el-input__prefix {
  left: 12px;
  display: flex;
  align-items: center;
  height: 100%;
}

.login-form .el-input__prefix i {
  color: #2a8ef1;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.captcha-img {
  width: 100px;
  height: 45px;
  background: linear-gradient(135deg, rgba(42, 142, 241, 0.2) 0%, rgba(0, 102, 204, 0.2) 100%);
  border: 1px solid rgba(42, 142, 241, 0.3);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.3s ease;
  overflow: hidden;
}

.captcha-img:hover {
  transform: scale(1.05);
  box-shadow: 0 0 15px rgba(42, 142, 241, 0.3);
}

.captcha-img span {
  color: #ffffff;
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 3px;
  user-select: none;
}

.login-form .el-checkbox {
  color: #ffffff;
  font-size: 14px;
}

.login-form .el-checkbox__label {
  color: #ffffff;
}

.login-form .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #2a8ef1;
}

.login-form .el-link {
  font-size: 14px;
}

.login-btn {
  width: 100%;
  height: 45px;
  background: linear-gradient(135deg, #2a8ef1 0%, #0066cc 100%);
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 4px 20px rgba(42, 142, 241, 0.4);
  transition: all 0.3s ease;
  margin-top: 10px;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(42, 142, 241, 0.6);
}

.login-btn:active {
  transform: translateY(0);
}

.login-btn .el-icon-loading {
  margin-right: 8px;
}

.login-footer {
  margin-top: 30px;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(42, 142, 241, 0.2);
}

.login-footer p {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  margin: 0;
}

.login-footer a {
  color: #2a8ef1;
  text-decoration: none;
  transition: color 0.3s ease;
}

.login-footer a:hover {
  color: #ffffff;
  text-shadow: 0 0 10px rgba(42, 142, 241, 0.5);
}

.el-form-item__error {
  color: #e74c3c;
  font-size: 12px;
}

@media (max-width: 480px) {
  .login-box {
    width: 90%;
    padding: 30px 20px;
  }
  
  .captcha-img {
    width: 80px;
    height: 40px;
  }
  
  .title {
    font-size: 18px;
  }
}
</style>
